module.exports = __webpack_public_path__ + "static/work_with_us-6043ada9e47d498bc6aae5fef76a43f1.gif";